import * as t from "io-ts";
import * as util from "../../shared/src/util";

export const codec = t.union([
    t.literal("user"),
    t.literal("sail_homes_staff"),
    t.literal("sail_legal_non_authoriser_staff"),
    t.literal("sail_legal_authoriser_staff"),
    t.literal("admin"),
]);

export type T = t.TypeOf<typeof codec>;

export const values = util.typeValuesFromCodec(codec.types as Array<t.LiteralC<T>>);

export const canApproveCaseEnquiries = (p: T): boolean => {
    switch (p) {
        case "sail_legal_authoriser_staff":
        case "admin":
            return true;
        case "user":
        case "sail_homes_staff":
        case "sail_legal_non_authoriser_staff":
            return false;
        default:
            return util.requireExhaustive(p);
    }
};

export type TSubmittedEnquiryStatus = "pending_approval" | "approved_unsent";

export const submittedEnquiryStatusForRole = (p: T): TSubmittedEnquiryStatus | null =>
    canApproveCaseEnquiries(p) ? "approved_unsent"
    : p === "sail_legal_non_authoriser_staff" ? "pending_approval"
    : null;
